import { useState } from 'react';
import './zipcode.css';
import { search_zipcode } from '../utils/restapi';
import ListBody from '../components/list/ListBody';
import ListFooter from '../components/list/ListFooter';

const Zipcode = ({ onSelected, onClose }) => {
  console.log('Zipcode props:', { onSelected, onClose }); // 디버깅용

  const [keyword, setKeyword] = useState('');
  const [zipcode, setZipcode] = useState('');

  const [total, setTotal] = useState(0);
  const [page, setPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [totalPages, setTotalPages] = useState(0);
  const [items, setItems] = useState([]);
  const [selectedItems, setSelectedItems] = useState([]);
  const [sort, setSort] = useState('');
  const [desc, setDesc] = useState('');

  // ListBody에서 사용할 헤더 정의
  const headers = [
    {
      name: '우편번호',
      value: 'zipcode',
      renderCell: (item) => item.zipcode
    },
    {
      name: '주소',
      value: 'addressMain',
      renderCell: (item) => (
        <div>
          <div>{item.addressMain}</div>
          <div>{item.jibunAddr}</div>
        </div>
      )
    },
    {
      name: '상세주소',
      value: 'addressDetail',
      renderCell: (item) => item.addressDetail
    }
  ];

  const handleSearch = async () => {
    if (keyword === '') {
      alert('검색어를 입력해주세요.');
      return;
    }

    console.log('검색 시작:', keyword);
    
    try {
      const searchParams = {
        page: 1,
        rowsPerPage: rowsPerPage,
        keyword: keyword.trim()
      };
      
      console.log('검색 파라미터:', searchParams);
      
      const results = await search_zipcode(searchParams);
      
      console.log('API 응답:', results);
      
      // 응답 처리
      if (results && results.lists) {
        setItems(results.lists);
        setTotal(results.total);
        setTotalPages(results.totalPages);
        setPage(results.page);
      } else {
        setItems([]);
        setTotal(0);
        setTotalPages(0);
        setPage(1);
      }
    } catch (error) {
      console.error('검색 오류:', error);
      alert('검색 중 오류가 발생했습니다: ' + error.message);
    }
  };

  // 페이지 변경 핸들러
  const handlePageChange = async (newPage) => {
    console.log('페이지 변경:', newPage);
    setPage(newPage);
    
    try {
      const searchParams = {
        page: newPage,
        rowsPerPage: rowsPerPage,
        keyword: keyword.trim()
      };
      
      const results = await search_zipcode(searchParams);
      
      console.log('페이지 변경 결과:', results);
      
      if (results && results.lists) {
        setItems(results.lists);
        setTotal(results.total);
        setTotalPages(results.totalPages);
      }
    } catch (error) {
      console.error('페이지 변경 오류:', error);
    }
  };

  // 전체 선택/해제
  const handleSelectAll = (checked) => {
    if (checked) {
      setSelectedItems(items.map((item, index) => index));
    } else {
      setSelectedItems([]);
    }
  };

  // 개별 선택
  const handleItemSelect = (itemIndex, checked) => {
    if (checked) {
      setSelectedItems([...selectedItems, itemIndex]);
    } else {
      setSelectedItems(selectedItems.filter(index => index !== itemIndex));
    }
  };

  // 정렬 변경
  const handleSortChange = (value, currentSort, setSort, setDesc) => {
    if (currentSort === value) {
      setDesc(desc === 'desc' ? 'asc' : 'desc');
    } else {
      setSort(value);
      setDesc('desc');
    }
  };

  // 행 클릭 핸들러 (주소 선택)
  const handleRowClick = (item) => {
    console.log('행 클릭:', item);
    
    const selectedData = {
      zipcode: item.zipcode,
      addressMain: item.addressMain,
      addressDetail: item.addressDetail || '',
      jibunAddr: item.jibunAddr
    };
    
    console.log('선택된 데이터:', selectedData);
    
    if (onSelected) {
      onSelected(selectedData);
    }
  };

  // 액션 버튼 렌더링
  const renderActions = (item, index) => {
    return (
      <button 
        onClick={(e) => {
          e.stopPropagation();
          handleRowClick(item);
        }}
        style={{ padding: '5px 10px', cursor: 'pointer' }}
      >
        선택
      </button>
    );
  };

  // 닫기 버튼 클릭 핸들러
  const handleCloseClick = () => {
    console.log('닫기 버튼 클릭됨');
    console.log('onClose 타입:', typeof onClose);
    console.log('onClose 값:', onClose);
    
    if (onClose && typeof onClose === 'function') {
      console.log('onClose 실행');
      onClose();
    } else {
      console.warn('onClose가 함수가 아니거나 없습니다:', onClose);
    }
  };

  // Enter 키 검색
  const handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      handleSearch();
    }
  };

  return (
    <div id="zipcode">
      <div className="head">
        <h1>우편번호 검색</h1>
      </div>
      <div className="body">
        <div style={{ marginBottom: '20px' }}>
          <input 
            type="text" 
            value={keyword} 
            onChange={(e) => setKeyword(e.target.value)} 
            onKeyPress={handleKeyPress}
            placeholder="도로명 주소나 건물명을 입력해주세요." 
            style={{ width: '70%', padding: '8px', marginRight: '10px' }}
          />
          <button onClick={handleSearch} style={{ padding: '8px 16px' }}>검색</button>
        </div>
        {items.length === 0 ? (
          <div style={{ padding: '20px', lineHeight: '1.6', color: '#666' }}>
            <p>
              동(읍/면/리)이나 도로명, 건물명을 입력 후 검색버튼을 눌러주세요.<br />
              예)서울시 강서구 등촌동 636-43 대륭빌딩의 경우<br />
              ①"등촌동"이나 "등촌동 636-43" 동명(지번)으로 검색<br />
              ②"공항대로55길"이나 "공항대로55길 47" 도로명(건물번호)으로 검색<br />
              ③"대륭빌딩" 이나 "서울시 대륭빌딩", "강서구 대륭빌딩", "서울시 강서구 대륭빌딩" 건물명으로 검색<br />
              상세 검색을 위해 시도, 구군, 동 등을 추가해 검색해 주십시오.<br />
              예)"서울시 공항대로55길", "강서구 공항대로55길", "서울시 강서구 공항대로55길" 등으로 검색<br />
              예)"옥련동 현대아파트", "연수구 옥련동 현대아파트" 등으로 검색<br />
            </p>
          </div>
        ) : (
          <div>
            <div style={{ marginBottom: '10px', fontWeight: 'bold' }}>
              총 {total}개의 결과가 있습니다. (페이지 {page} / {totalPages})
            </div>
            
            <ListBody
              headers={headers}
              items={items}
              selectedItems={selectedItems}
              handleSelectAll={handleSelectAll}
              handleItemSelect={handleItemSelect}
              sort={sort}
              desc={desc}
              handleSortChange={handleSortChange}
              setSort={setSort}
              setDesc={setDesc}
              renderActions={renderActions}
              onRowClick={handleRowClick}
              className="zipcode_table"
              isCart={false}
            />

            <ListFooter
              page={page}
              totalPages={totalPages}
              showPageNum={10}
              handlePageChange={handlePageChange}
            />
          </div>
        )}
      </div>
      <div className="foot">
        <button onClick={handleCloseClick}>닫기</button>
      </div>
    </div>
  );
};

export default Zipcode;